import { LessonKeys } from '@/appcfg';

const SkillSurveyMap: Partial<{[skill in LessonKeys]: string}> = {
    Reflection: "https://redcap.iths.org/surveys/?s=8R78MRPD3ATN8TH3",
    Empathy: "https://redcap.iths.org/surveys/?s=4EJ74MLDTTNC4MAR",
    "Cultural Responsiveness": "https://redcap.iths.org/surveys/?s=WPDRL8EPCY8T4HXY",
    "Agenda Setting and Symptom Review": "https://redcap.iths.org/surveys/?s=XPEF9MAWC47JPCED",
    "Enhancing Motivation": "https://redcap.iths.org/surveys/?s=7DJW83YW4YJMD89P",
    Redirection: "https://redcap.iths.org/surveys/?s=DWEFWPWKW9KAELKH",
    "Assigning Homework": "https://redcap.iths.org/surveys/?s=EH3YHLX8Y9K3HWEF",
    "Reviewing Homework": "https://redcap.iths.org/surveys/?s=7LYDK9T8HWD83MH9",
    "Assessing Suicide Risk": "https://redcap.iths.org/surveys/?s=FR9CDLLK4TH4CWNT",
    "Managing Mild to Moderate Suicide Risk": "https://redcap.iths.org/surveys/?s=8XFK8J9NRX439ADF",
    "Managing Severe Suicide Risk": "https://redcap.iths.org/surveys/?s=YNR9WA77KMYAHP9K"
  };

export const getEndOfModuleSurveyLink = (skillName: string): string | undefined => {
  const lessonKey = skillName as LessonKeys;
  return SkillSurveyMap[lessonKey];
};

export const generateEndOfModuleSurveyLink = (skillName: string, classCode: string, userId: string): string | undefined => {
  const lessonKey = skillName as LessonKeys;
  // Don't generate survey if skill doesn't exist from predefined set
  if (!lessonKey || !classCode) {
    return undefined;
  }

  // Redcap surveys allow for auto population of fields via url parameters
  const url = new URL('https://redcap.iths.org/surveys/?s=DCD9LNMNEXWKXCCE');
  url.searchParams.append('its_module', skillName);
  url.searchParams.append('its_class_id', classCode);
  url.searchParams.append('its_uid', userId);
  return url.toString();
};